export default "__VITE_ASSET__BTiqhosd__"